/* eslint-disable no-nested-ternary */
import React from 'react';
import { Reorder, motion } from 'framer-motion';
import { colorPalette } from '@lib/constants';
import { parseColorToRgba } from '@services/interactions-service';

const FantasticFansItem = ({
  fans,
  colors,
  fontSize = '32px',
  animatedCount = 0,
  fontFamily = 'Inter',
  animatedRelativePercentage = 0,
  isTrackModal = false
}) => {
  return (
    <div className="w-full inline-flex flex-col justify-start items-start gap-4">
      {fans.map(({ id, commenterName, count, relativePercentage }, index) => {
        const barColor = parseColorToRgba(colors?.fantasticFansChartColor || '#F97B5F', 1);
        const textColor = barColor === parseColorToRgba(colors?.ffTextColor || '#000000', 1)
          ? '#000000'
          : (colors?.ffTextColor || '#000000');

        return (
          <Reorder.Item
            as="div"
            key={id || index}
            value={id || index}
            style={{
              background: parseColorToRgba(colors?.fantasticFansChartColor || '#F97B5F', 0.4),
              height: isTrackModal ? '56px' : '80px',
            }}
            className={`relative ${isTrackModal ? 'w-[896px] mx-auto' : 'w-full'} rounded-[50px] transition-all overflow-hidden`}
            layout
            transition={{ type: 'spring', stiffness: 40, damping: 20 }}
          >
            <motion.div
              style={{ background: barColor }}
              className="absolute inset-y-0 left-0"
              initial={{ width: 0 }}
              animate={{ width: `${relativePercentage}%` }}
              transition={{ duration: 1.2, ease: 'easeOut' }}
            />

            <div className="relative z-10 w-full flex items-center justify-between gap-4 pr-6" style={{ height: isTrackModal ? '56px' : '80px' }}>
              <div className="flex items-center gap-4 min-w-0" style={{ height: isTrackModal ? '56px' : '80px' }}>
                <div
                  className="aspect-square rounded-full flex justify-center items-center shrink-0"
                  style={{ height: isTrackModal ? '56px' : '80px', width: isTrackModal ? '56px' : '80px', fontFamily, backgroundColor: colorPalette[index % colorPalette.length] }}
                >
                  <div className="text-[#212121] text-3xl font-semibold leading-none">
                    {commenterName?.charAt(0)}
                  </div>
                </div>
                <div
                  style={{ fontFamily, fontSize, color: textColor }}
                  className="font-normal leading-none line-clamp-1"
                >
                  {commenterName}
                </div>
              </div>

              <motion.div
                initial={{ opacity: 0, y: -5 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                style={{ fontFamily, fontSize, color: textColor }}
                className="font-normal leading-none shrink-0"
              >
                {id !== undefined ? animatedCount[id] : fans[index]?.count || 0}
              </motion.div>
            </div>
          </Reorder.Item>
        );
      })}
    </div>
  );
};

export default FantasticFansItem;
